"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfirmationModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _ActionButton = _interopRequireDefault(require("../ActionButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * `ConfirmationModal` is a specialised version of the [Modal](?path=/docs/modal--default-story) component to prompt a confirmation from the user before executing an action.
 */
const ConfirmationModal = _ref => {
  let {
    cancelButtonLabel = "Cancel",
    cancelButtonProps,
    children,
    confirmButtonAppearance = "negative",
    confirmButtonLabel,
    confirmExtra,
    onConfirm,
    confirmButtonLoading,
    confirmButtonDisabled,
    confirmButtonProps,
    ...props
  } = _ref;
  const handleClick = action => event => {
    if (!props.shouldPropagateClickEvent) {
      event.stopPropagation();
    }
    if (action) {
      action(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({
    buttonRow: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, confirmExtra, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, cancelButtonProps, {
      className: "u-no-margin--bottom",
      onClick: handleClick(props.close)
    }), cancelButtonLabel), /*#__PURE__*/_react.default.createElement(_ActionButton.default, _extends({}, confirmButtonProps, {
      appearance: confirmButtonAppearance,
      className: "u-no-margin--bottom",
      onClick: handleClick(onConfirm),
      loading: confirmButtonLoading,
      disabled: confirmButtonDisabled
    }), confirmButtonLabel))
  }, props), children);
};
exports.ConfirmationModal = ConfirmationModal;
var _default = exports.default = ConfirmationModal;